import { clamp } from "./math";
import type { Vec2 } from "./types";

export const bossDrawSize = (compactCombat: boolean): number =>
  compactCombat ? 200 : 250;

/** 短横屏不缩小玩家，只适配首领表现尺寸；在能同时容纳时夹紧镜头，避免插值再次裁头。 */
export function frameCloseBoss(
  cameraY: number,
  player: Vec2,
  boss: Vec2 | undefined,
  viewportHeight: number,
  scale: number,
  compactCombat: boolean,
): number {
  if (
    !compactCombat ||
    !boss ||
    Math.abs(player.x - boss.x) > 240 ||
    Math.abs(player.y - boss.y) > 160
  )
    return cameraY;
  const half = viewportHeight / scale / 2,
    padding = 6 / scale;
  const top = Math.min(
    player.y - (126 * 148) / 160,
    boss.y - (bossDrawSize(true) * 238) / 256,
  );
  const bottom = Math.max(player.y + (126 * 12) / 160, boss.y + 34);
  const minimum = bottom - half + padding,
    maximum = top + half - padding;
  return minimum <= maximum ? clamp(cameraY, minimum, maximum) : cameraY;
}
